import './front.scss';
import { IconGridFront } from './IconGridFront.js';

new IconGridFront( document ).init();
